export default __webpack_public_path__ + "static/media/intervention-calls.4191e0db.svg";